// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-1ea57e40]{width:calc(var(--inner-width)*1px);margin:0 auto}[data-v-1ea57e40] .el-divider{background-color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
